module.exports = __webpack_public_path__ + "static/media/lal-logo.a2d68c0b.png";